import React, { useEffect, useState } from 'react';
export function Hero() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);
  return <section className="relative min-h-screen flex flex-col justify-center pt-24 pb-20 px-6 overflow-hidden" style={{
    backgroundColor: 'var(--bg)'
  }} data-id="element-24">
      {/* Subtle background dots echoing logo colors */}
      <div className="absolute top-32 right-16 w-3 h-3 rounded-full opacity-60" style={{
      backgroundColor: 'var(--blue)'
    }} data-id="element-25" />
      <div className="absolute top-48 right-28 w-2 h-2 rounded-full opacity-40" style={{
      backgroundColor: 'var(--pink)'
    }} data-id="element-26" />
      <div className="absolute bottom-32 left-16 w-2 h-2 rounded-full opacity-40" style={{
      backgroundColor: 'var(--orange)'
    }} data-id="element-27" />
      <div className="absolute bottom-48 left-32 w-3 h-3 rounded-full opacity-30" style={{
      backgroundColor: 'var(--green)'
    }} data-id="element-28" />

      <div className="max-w-6xl mx-auto w-full" data-id="element-29">
        {/* Main headline — 3/4 page width, max 3 lines */}
        <div className="transition-all duration-700 ease-out" style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(24px)',
        transitionDelay: '0ms'
      }} data-id="element-30">
          <h1 className="leading-[1.1] tracking-tight mb-8" style={{
          fontFamily: 'var(--font-heading)',
          fontSize: 'var(--text-display)',
          color: 'var(--text)',
          maxWidth: '75%'
        }} data-id="element-31">
            A product design studio
            <br data-id="element-32" />
            for early and growth-stage startups
          </h1>
        </div>

        {/* Body text — same width as title */}
        <div className="transition-all duration-700 ease-out" style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(24px)',
        transitionDelay: '100ms'
      }} data-id="element-33">
          <p className="leading-relaxed mb-8" style={{
          color: 'var(--text-muted)',
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--text-body)',
          fontWeight: '400',
          maxWidth: '60%'
        }} data-id="element-34">
            We are a collection of senior-level product designers you can drop
            into your team. We bring design judgement, the latest AI tools, and
            years of experience to help you build 0 to 1 or accelerate your
            growth.
          </p>
        </div>

        {/* CTA — below body text */}
        <div className="transition-all duration-700 ease-out" style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(24px)',
        transitionDelay: '200ms'
      }} data-id="element-35">
          <a href="https://calendly.com/danielle-abc/30min" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-7 py-3.5 rounded-full text-sm font-semibold transition-all duration-200 hover:opacity-80" style={{
          backgroundColor: 'var(--text)',
          color: 'var(--bg)',
          fontFamily: 'var(--font-sans)'
        }} data-id="element-36">
            Book now
          </a>
        </div>
      </div>
    </section>;
}